import React from "react";
import { Spinner, Card } from "react-bootstrap";

const FullPageLoader = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-dark p-4"
      style={{ backgroundColor: "black" }}
    >
      <Card className="w-100 shadow-lg" style={{ maxWidth: "0px", backgroundColor:"#000" }}>
        <Card.Body>
          <Spinner animation="border" variant="primary" />
        </Card.Body>
      </Card>
    </div>
  );
};

export default FullPageLoader;

